import EitherOrResultsBreakdownModel from "./EitherOrResultsBreakdownModel";
import EitherOrResultsStandingsModel from "./EitherOrResultsStandingsModel";

export default class EitherOrResultsModel {
  public standings: EitherOrResultsStandingsModel[] = [];
  public breakdown: EitherOrResultsBreakdownModel[] = [];
}
